import { useRouter } from 'next/router';
import styles from './index.module.scss';
import useOpenAiChat from './useOpenAiChat';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import { OuterRingIcon, RobotIcon } from '@/components/MicrosoftChat/icons';

const langTxt: any = {
    us: `I'm online! Your Inteligent assistant is here ✨`,
    en: `I'm online! Your AI assistant is here ✨`,
    de: 'Ich bin online! Ihr KI-Assistent ist da ✨',
    jp: 'オンラインになりました！AIサポート登場 ✨',
    cn: '我上线啦！AI客服上线报道 ✨',
    fr: 'Je suis en ligne ! Votre assistant IA est là ✨',
};

const whiteDomainList = ['/chat', '/delta-pro-ultra-x'];
const FixIcon: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('FixIcon');

    // 获取域名
    const router = useRouter();

    // console.log(router);

    if (whiteDomainList.includes(router.pathname)) {
        return null;
    }

    const { handleOpenChat } = useOpenAiChat();

    // const handleOpenChat = () => {
    //     // 使用固定的窗口名称 'ecoflowChat'，确保只打开一个窗口
    //     // 如果窗口已存在，会聚焦到该窗口而不是打开新的
    //     const chatUrl = `/${locale}/chat?source=${router.pathname}`;
    //     const windowName = 'ecoflowChat';
    //     const windowFeatures = 'width=1200,height=800,left=100,top=100,resizable=yes,scrollbars=yes';

    //     window.open(chatUrl, windowName, windowFeatures);

    //     gtm.push({
    //         event: 'uaEvent',
    //         event_name: 'click_on_chat',
    //         page_name: router.pathname,
    //         button_name: 'Start Chatting',
    //         navigation_name: `/${locale}/chat`,
    //         tag: '',

    //         __btn_type: 'common',
    //         __btn_id1: 'gtm-fix-icon',
    //         __btn_id2: 'gtm-fix-icon',
    //     });
    // };

    return (
        <div
            className={styles.FixIcon + ' gtm-fix-icon GtmModuleData-btn-common '}
            data-btn-id="gtm-fix-icon"
            onClick={handleOpenChat}
            style={{ cursor: 'pointer' }}
        >
            <div className="icon-box">
                <div className={'out-ring-icon'}>
                    <OuterRingIcon />
                </div>
                <div className={'robot-icon'}>
                    <RobotIcon />
                </div>
            </div>

            <div className={'chat-tips'}>
                <span className={styles.chatTipsTxt}>{t('title')}</span>
            </div>
        </div>
    );
};

export default FixIcon;
